const helper = {
  state: {
    id: ""
      //id: 'TkIJIXX0gNbxWd4UXWfvxA==',
  },
  mutations: {
    SET_ID: (state, id) => {
      state.id = id;
    }
  },
  actions: {}
};

export default helper;
